
import { defineComponent } from "vue";
import CronometroVue from "@/components/CronometroVue.vue";
import Botao from "@/components/Botao.vue";

export default defineComponent({
  name: 'TemporizadorVue',
  emits: ['aoTemporizadorFinalizado'],
  components: {
    CronometroVue,
    Botao,
  },
  data () {
    return {
      tempoSegundos: 0,
      cronometro: 0,
      cronometroRodando: false,
    }
  },

  methods: {
    iniciar () : void {
      this.cronometroRodando = true;
      this.cronometro = setInterval(() => {
        this.tempoSegundos++;
      }, 1000);
    },
    finalizar () : void {
      this.cronometroRodando = false;
      clearInterval(this.cronometro);
      this.$emit('aoTemporizadorFinalizado', this.tempoSegundos);
      this.tempoSegundos = 0;
    },
  }
});

